import type { ProductFragmentEnhanced } from '@models/enhanced-fragments';

export const getUniqueAssociatedProductIds = (products: ProductFragmentEnhanced[] = []) =>
  products
    .flatMap(product => product.product_to_product_associations)
    .map(associatedProduct => associatedProduct.productByProductIdTarget?.id)
    .filter((sku): sku is string => !!sku)
    .filter((sku, index, skuArray) => skuArray.indexOf(sku) === index);
